// Tap the culprit: which answer option each bloods row stands for. The set builder names row options R1…Rn in
// row order; a row whose option is named otherwise is matched by its test name. Options that match no row are
// returned so the screen can still offer them.
import type { BloodsRow, Option } from '@shared/types';

export interface SpotMap {
  /** The option id for each row, by row index; undefined when no option stands for that row. */
  rowOption: Array<string | undefined>;
  /** Options that stand for no row. */
  unmatched: Option[];
}

const norm = (s: string) => s.toLowerCase().replace(/\s+/g, ' ').replace(/[.:;,]+$/, '').trim();

export function mapSpotRows(rows: ReadonlyArray<BloodsRow>, options: ReadonlyArray<Option>): SpotMap {
  const used = new Set<string>();
  const rowOption: Array<string | undefined> = rows.map((_, i) => {
    const byId = options.find((o) => !used.has(o.id) && o.id.toUpperCase() === `R${i + 1}`);
    if (byId) { used.add(byId.id); return byId.id; }
    return undefined;
  });
  rows.forEach((r, i) => {
    if (rowOption[i]) return;
    const test = norm(r.test);
    const byText = options.find((o) => !used.has(o.id) && (norm(o.text) === test || norm(o.text).startsWith(`${test} `) || norm(o.text).startsWith(`${test}:`)));
    if (byText) { used.add(byText.id); rowOption[i] = byText.id; }
  });
  return { rowOption, unmatched: options.filter((o) => !used.has(o.id)) };
}
